import React from "react"
import type { CustomFieldSelect } from "@love-irish/types"
import { Badge } from "@love-irish/ui-components"

const SelectField = ({ field }: { field: CustomFieldSelect }) => {
  return (
    <Badge variant="outline">
      <strong className="mr-1">{field.label}:</strong> {field.value}
    </Badge>
  )
}

export default SelectField
